'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('react');
var icons_AlertTriangleOutline = require('../../../icons/AlertTriangleOutline.js');
var icons_BulbOutline = require('../../../icons/BulbOutline.js');
var icons_CheckmarkOutline = require('../../../icons/CheckmarkOutline.js');
var icons_InfoOutline = require('../../../icons/InfoOutline.js');
var icons_LoaderOutline = require('../../../icons/LoaderOutline.js');

const returnIcon = (variant) => {
    if (variant === "helper")
        return icons_BulbOutline;
    if (variant === "error")
        return icons_AlertTriangleOutline;
    if (variant === "warning")
        return icons_InfoOutline;
    if (variant === "validated")
        return icons_CheckmarkOutline;
    if (variant === "validating")
        return icons_LoaderOutline;
    if (variant === "password")
        return null;
    return icons_BulbOutline;
};

exports.returnIcon = returnIcon;
